import type { LocaleWithFormats } from "@hakunajs/vue-translate"

const datetimeFormats: LocaleWithFormats = {
  de: {
    date: {
      short: {
        year: "numeric",
        month: "short",
        day: "numeric",
      },
      long: {
        year: "numeric",
        month: "long",
        day: "numeric",
        weekday: "long",
        hour: "numeric",
        minute: "numeric",
      },
    },
    number: {},
  },
  en: {
    date: {
      short: {
        year: "numeric",
        month: "short",
        day: "numeric",
      },
      long: {
        year: "numeric",
        month: "long",
        day: "numeric",
        weekday: "long",
        hour: "numeric",
        minute: "numeric",
      },
    },
    number: {},
  },
}

export default datetimeFormats
